import Vue from "vue";
import VueResource from "vue-resource";
import Raven from "raven-js";
import dayjs from "dayjs";
import iOrder from "@/libs/plugins/iOrder";

export default {
  async fetchOrderNumber({ commit, getters, state }) {
    try {
      const user = getters.getCurrentUser;
      const userEmail = user.email;
      const successData = getters.getSuccessData;
      const uniqueRef = successData && successData.uniqueRef;
      console.log({ uniqueRef });
      const usersOrdersRes = await iOrder.fetchUsersOrders({
        userEmail,
        identifier: "Web - iOrderCore",
        config: state.config,
      });
      const usersOrders =
        usersOrdersRes && usersOrdersRes.body && usersOrdersRes.body.myOrders;
      if (usersOrdersRes.status === 200) {
        const linkedOrder = usersOrders.filter(
          (i) => i.uniqueReference === uniqueRef
        )[0];
        const orderNumber = linkedOrder && linkedOrder.accountNumber;
        if (orderNumber) {
          commit("setOrderNumber", { orderNumber });
        } else {
          commit("setOrderNumber", {
            orderNumber: "error: please find a member of staff to help",
          });
        }
      } else {
        commit("setOrderNumber", {
          orderNumber: "error: please find a member of staff to help",
        });
      }
    } catch (error) {
      console.log("Error fetching order number");
      commit("setOrderNumber", {
        orderNumber: "error: please find a member of staff to help",
      });
    }
  },
  showGuestLoginModal({ commit }) {
    commit("showModal", {
      modal: "GuestLoginModal",
    });
  },
  hideModal({ commit }) {
    commit("hideModal");
  },
  async submitGuestDetails({ commit }, { email, name, phone }) {
    return new Promise((resolve) => {
      commit("setGuestDetails", { email, name, phone });
      setTimeout(resolve, 1000);
    });
  },
  showCheckoutModal({ commit }) {
    commit("showModal", {
      modal: "checkoutModal",
    });
  },
  clearState({ commit }) {
    commit("clearState");
  },
  showToast({ commit }, { detail, size }) {
    const className = size ? `iorderauth-toast-${size}` : "iorderauth-toast";

    Vue.toasted.show(detail, {
      theme: "primary",
      className,
      closeOnSwipe: true,
      containerClass: "iorderauth",
      duration: 4000,
      fullWidth: true,
      fitToScreen: true,
      position: "bottom-center",
      singleton: true,
    });
  },
  async checkBasket(
    { state, getters, commit, dispatch },
    {
      siteId,
      salesAreaId,
      basketLines,
      voucherLines,
      serviceId,
      user,
      timeslot,
    }
  ) {
    commit("clearStatusData");
    return new Promise((resolve, reject) => {
      if (dayjs().isAfter(dayjs(timeslot))) {
        return resolve({
          success: false,
          status: "timeslotUnavailable",
        });
      }

      iOrder.checkBasket(
        {
          siteId,
          salesAreaId,
          basketLines,
          voucherLines,
          serviceId,
          user,
          timeslot,
          config: state.config,
          identifier: "Web - iOrderCore",
        },
        (err, res) => {
          if (err) {
            dispatch("showToast", {
              detail: "Oops, something went wrong, please try again.",
            });
            console.log(err);
            return resolve({
              success: false,
              status: "Oops, something went wrong, please try again.",
            });
          } else if (res.response === "Error") {
            if (/log in/i.test(res.detail)) {
              dispatch("showToast", {
                detail: "Oops, you need to be logged in to place and order.",
              });
              return resolve({
                success: false,
                status: "authRequired",
              });
            }

            if (
              /please make another selection/i.test(res.detail) ||
              /please select another/i.test(res.detail)
            ) {
              dispatch("showToast", { detail: res.detail });
              return resolve({
                success: false,
                status: "unavailableLines",
                ingredientId: res.ingredientId,
              });
            }

            if (/time is no longer available/i.test(res.detail)) {
              return resolve({
                success: false,
                status: "timeslotUnavailable",
              });
            }

            if (
              /more than one of these discounts cannot be applied/i.test(
                res.detail
              ) ||
              /vouchers have timed out/i.test(res.detail)
            ) {
              return resolve({
                success: false,
                status: "voucherError",
              });
            }

            return resolve({
              success: false,
              status: res.detail,
            });
          }

          let discountLines = res.lines.filter(
            (item) => item.amount && item.amount < 0
          );
          discountLines = discountLines.length ? discountLines : [];
          discountLines = discountLines.map((item) => item.amount);
          const promotionDiscount = discountLines.reduce(
            (sum, amount) => sum + amount,
            0
          );

          const voucherLines = res.voucherLines
            ? res.voucherLines.map((voucherLine) => voucherLine.Amount)
            : [];
          const voucherDiscount = voucherLines.reduce(
            (sum, amount) => sum + amount,
            0
          );

          commit("setCheckoutData", {
            btToken: res.braintreeToken,
            basketTotal: res.basketTotal,
            basketId: res.basketId,
            promotionDiscount,
            voucherDiscount,
          });

          commit("setVoucherDetail", {
            voucherDetail: res.voucherLines[0],
          });

          return resolve({
            success: true,
          });
        }
      );
    });
  },
  async checkVoucher(
    { state, getters, commit, dispatch },
    { siteId, salesAreaId, voucherCode, identifier }
  ) {
    return new Promise((resolve, reject) => {
      iOrder.checkVoucher(
        { siteId, salesAreaId, voucherCode, identifier, config: state.config },
        (err, res) => {
          if (err) {
            dispatch("showToast", {
              detail: "Oops, something went wrong, please try again.",
            });
            console.log(err);
            return resolve({
              success: false,
              status: "Oops, something went wrong, please try again.",
            });
          } else if (res.response === "Error") {
            if (/an error has occurred/i.test(res.detail)) {
              return resolve({
                success: false,
                status: "invalidVoucherCode",
              });
            }

            return resolve({
              success: false,
              status: res.detail,
            });
          }

          return resolve({
            success: true,
            voucherCode: res.voucher.voucherCode,
          });
        }
      );
    });
  },
  async makeBraintreePayment(
    { state, getters, commit, dispatch },
    { nonce, type, description, deviceData, salesData, user }
  ) {
    commit("clearStatusData");
    const basketId = state.requiredCheckoutData.basketId;
    return new Promise((resolve, reject) => {
      iOrder.makeBraintreePayment(
        {
          config: state.config,
          siteId: salesData.siteId,
          salesAreaId: salesData.salesAreaId,
          table: salesData.tableNumber,
          paymentMethod: state.paymentIds[type] || 54,
          user,
          basketId,
          nonce,
          description,
          deviceData,
        },
        (err, res) => {
          if (err) {
            commit("setPaymentError", { message: err.detail });
            return resolve({
              success: false,
              status: "authRequired",
            });
          } else if (res.response === "Error") {
            if (/log in/i.test(res.detail)) {
              commit("setPaymentError", {
                message: "You must be logged in to place an order",
              });
              return resolve({
                success: false,
                status: "authRequired",
              });
            }
            commit("setPaymentError", {
              message: "Oops, something went wrong, please try again",
            });
            return resolve({
              success: false,
              status: "unknown",
            });
          }

          commit("setTransactionDetails", {
            paidBy: res.paidBy,
            uniqueRef: res.uniqueRef,
            receiptEmail: res.userEmailAddress,
          });
          return resolve({
            success: true,
          });
        }
      );
    });
  },
  async dispatchAlert({ rootState, state }, { alertsCode }) {
    const alertsUrl =
      state.alertsUrl || "https://alerts-api-stage.omnifitrgsites.co.uk";
    const url = `${alertsUrl}/events`;
    const vueInstance = Vue;

    const transactionDetails = {
      brand: rootState.site.brandName,
      type: "COAT",
      order_number: state.successData.uniqueRef,
      total: state.requiredCheckoutData.basketTotal,
      time_of_transaction: new Date(),
      customer_email: rootState.iOrderCheckout.user.email,
      table_number: rootState.iOrderCore.requiredSalesData.tableNumber,
      restaurant_id: rootState.site.trgSiteId,
    };

    return new Promise((resolve, reject) => {
      vueInstance.http.post(url, transactionDetails).then(
        (res) => {
          resolve();
          return res;
        },
        (err) => {
          reject();
          return err;
        }
      );
    });
  },
  getProductPrice({ rootGetters }, { item }) {
    const productDetails = rootGetters["iOrderCore/getProduct"](
      item.ingredientId
    );
    const itemPrice =
      productDetails &&
      productDetails.portions &&
      productDetails.portions.find(
        (portion) => portion.id === item.portionTypeId
      ).price;
    const choiceSum =
      item.choiceLines &&
      item.choiceLines.reduce((choiceSum, choice) => {
        const aztecChoice = rootGetters["iOrderCore/getProduct"](
          choice.ingredientId
        );
        return (
          choiceSum +
          ((aztecChoice &&
            aztecChoice.portions &&
            aztecChoice.portions[0] &&
            aztecChoice.portions[0].price) ||
            0)
        );
      }, 0);
    return itemPrice + choiceSum;
  },
  async submitEcomTracking(
    { state, getters, rootGetters, dispatch },
    { affiliation, env }
  ) {
    if (env !== "production") {
      return;
    }
    const basket = rootGetters["iOrderCore/getBasket"];
    const purchaseId =
      (getters.getEcomTrackingData && getters.getEcomTrackingData.uniqueRef) ||
      "";
    const items = [];

    if (basket && basket.lines && basket.lines.length) {
      for (const item of basket.lines) {
        const productSummary = rootGetters["iOrderCore/getProductSummary"](
          item
        );
        const id =
          (productSummary &&
            productSummary.SKU &&
            productSummary.SKU.toString()) ||
          "";
        const name = (productSummary && productSummary.productName) || "";
        const brand = `${affiliation}`;
        const category =
          rootGetters["iOrderCore/getDisplayGroupName"](item.ingredientId) ||
          "";
        const price = await dispatch("getProductPrice", { item });
        const quantity = productSummary && productSummary.quantity;
        let variant = [];

        if (item.choiceLines && item.choiceLines.length) {
          item.choiceLines.forEach((choiceLine) => {
            const choiceItemSummary = rootGetters["iOrderCore/getProduct"](
              choiceLine.ingredientId
            );
            if (choiceItemSummary && choiceItemSummary.eposName) {
              variant.push(choiceItemSummary.eposName);
            }
          });
        }
        variant = variant.join(", ");

        if (id || name) {
          try {
            items.push({
              id,
              name,
              brand,
              category,
              variant,
              price,
              quantity,
            });
          } catch (err) {
            Raven.captureException(err);
          }
        } else {
          Raven.captureException(
            "Enhanced ecommerce: missing id or name on addProduct"
          );
        }
      }
    }
    if (purchaseId) {
      try {
        Vue.$gtag.purchase({
          id: purchaseId,
          affiliation,
          revenue: getters.getEcomTrackingData.basketTotal,
          shipping: 0.0,
          coupon:
            (rootGetters["iOrderCore/getVoucher"] &&
              rootGetters["iOrderCore/getVoucher"].getVoucherDetail &&
              rootGetters["iOrderCore/getVoucher"].getVoucherDetail.voucher &&
              rootGetters["iOrderCore/getVoucher"].getVoucherDetail.voucher
                .metaData &&
              rootGetters["iOrderCore/getVoucher"].getVoucherDetail.voucher
                .metaData.description) ||
            "",
            items
        });
      } catch (err) {
        Raven.captureException(err);
      }
    } else {
      Raven.captureException("Enhanced ecommerce: missing purchaseId");
    }
  },
};
